import { createContext, useContext } from 'react';

import type { Gesto, StatoSocial } from '@/lib/qgammon/storicoPartite';

/** Il contesto e il suo hook stanno qui e non accanto al provider: un file di componenti non esporta altro (fast refresh). */

export interface StatoAvversariApi {
  /** Lo stato corrente: il cambiamento fatto da un gesto se c'e', altrimenti quello del lotto (o `null`). */
  statoDi: (sub: string, dalLotto: StatoSocial | null) => StatoSocial | null;
  /** Un gesto di questo avversario e' in volo: tutte le sue righe tengono fermi i bottoni. */
  inVolo: (sub: string) => boolean;
  /** L'ultimo gesto di questo avversario e' fallito (si azzera al tentativo dopo). */
  fallito: (sub: string) => boolean;
  /** La serratura della sfida, letta una volta per la lista. */
  sfidaAccesa: boolean;
  /** Il tocco di una icona. `profilo`, `sfida` e `rimuovi` non scrivono: aprono una schermata o chiedono conferma. */
  esegui: (sub: string, nome: string, gesto: Gesto, dalLotto: StatoSocial | null) => void;
}

export const ContestoStatoAvversari = createContext<StatoAvversariApi | null>(null);

export function useStatoAvversari(): StatoAvversariApi {
  const c = useContext(ContestoStatoAvversari);
  if (!c) throw new Error('useStatoAvversari fuori da <StatoAvversariProvider>');
  return c;
}
